module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dpxj9"))).then(() => parcelRequire('hEqeo'));